// src/components/SentryProvider.tsx
"use client";

import { useEffect } from "react";
import * as Sentry from "@sentry/react";
import { initSentry } from "@/lib/sentry";

function SentryFallback() {
  return (
    <div className="min-h-screen bg-bg flex items-center justify-center p-4">
      <div className="bg-panel rounded-lg shadow-xl p-8 max-w-md w-full text-center border border-line">
        <h2 className="text-xl font-semibold text-ink mb-3">
          Something went wrong
        </h2>
        <p className="text-muted mb-6">
          An unexpected error occurred. Please reload the page.
        </p>
        <button
          onClick={() => window.location.reload()}
          className="px-6 py-3 bg-accent text-onbright hover:opacity-90 rounded-xl font-semibold transition-all cursor-pointer"
        >
          Reload page
        </button>
      </div>
    </div>
  );
}

export function SentryProvider({ children }: { children: React.ReactNode }) {
  useEffect(() => {
    initSentry();
  }, []);

  return (
    <Sentry.ErrorBoundary fallback={<SentryFallback />}>
      {children}
    </Sentry.ErrorBoundary>
  );
}
